import { useEffect, useState } from 'react'
import { FunnelIcon } from '@phosphor-icons/react'
import { ScoopCheckbox, ScoopRow } from '../../../../../ui'
import FilterModal from './FilterModal'
import { packFilter } from './Filter'
import styles from './ColumnHeader.module.scss'

const menuItems = [
    { label: 'Equals', value: 'Equals' },
    { label: 'Not Equals', value: 'NotEquals' },
    { label: 'Is Null', value: 'IsNull' },
    { label: 'Is Not Null', value: 'IsNotNull' },
    { label: 'Like', value: 'Like' },
]

const ColumnHeader = ({
    editingAnchorEl,
    isChecked,
    sheetID,
    headerName,
    inputQuery,
    setCurrentColumns,
    filterList,
    setFilterList,
    server,
    updatePreviewData,
    setColumns,
}) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [operator, setOperator] = useState('Equals')
    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined

    const [checked, setChecked] = useState(isChecked)
    const [changes, setChanges] = useState(false)
    const [allValues, setAllValues] = useState([])
    const [filterListCopy, setFilterListCopy] = useState([...filterList])

    const [operatorValues, setOperatorValues] = useState(
        filterListCopy
            .filter((f) => f.attributeName === headerName)
            .map((f) => f.operator)
            .filter((value) => value !== undefined)
    )

    useEffect(() => {
        async function fetchData() {
            await handleClickFilter()
        }
        if (editingAnchorEl && editingAnchorEl.column === headerName) {
            setAnchorEl(editingAnchorEl.anchorEl)
            fetchData()
        }
    }, [editingAnchorEl])

    useEffect(() => {
        if (isChecked === checked) return
        setChecked(isChecked)
    }, [isChecked])

    useEffect(() => {
        setFilterListCopy([...filterList])
    }, [filterList])

    const saveFilter2 = async (newFilterList) => {
        let updatedFilterList = []

        if (newFilterList.length === 0) {
            // If newFilterList is empty, remove all filters for the current header
            updatedFilterList = filterListCopy.filter((f) => f.attributeName !== headerName)
        } else {
            // Otherwise, update filter list with new filters
            updatedFilterList = filterListCopy
                .filter(
                    (existingFilter) =>
                        !newFilterList.some(
                            (ff) =>
                                ff.attributeName === existingFilter.attributeName &&
                                ff.operator === existingFilter.operator
                        )
                )
                .concat(newFilterList)
                .filter((f) => f.operator !== undefined)
        }

        if (!changes) {
            handleClose()
            return
        }

        setFilterList(updatedFilterList)
        inputQuery.filter = packFilter(updatedFilterList)
        //await updatePreviewData(inputQuery);
        handleClose()
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleOpen = async (event) => {
        setAnchorEl(event.currentTarget.parentElement.parentElement)
        await handleClickFilter()
    }

    const handleClickCheckbox = (event) => {
        const col = event.target.name
        setChecked((prev) => !prev)
        if (checked) {
            setColumns((prev) => {
                return prev.filter((c) => c !== col)
            })
        } else {
            setColumns((prev) => {
                return [...prev, col]
            })
        }
        setCurrentColumns(col)
    }

    const setCategoryValues = ({ values: categories }) => {
        const newItems = categories.filter((category) => category !== null)
        setAllValues(newItems)
    }

    const handleClickFilter = async () => {
        let action = {
            action: 'addOn',
            addOnAction: 'getCategoryValues',
            tableID: inputQuery.tableID,
            columnName: headerName,
            sheetID: sheetID,
        }
        await server.sheetPostData(action, setCategoryValues)
    }

    return (
        <ScoopRow className={styles.container}>
            <ScoopRow className={styles.columnInfo}>
                <ScoopCheckbox
                    className={styles.checkbox}
                    name={headerName}
                    checked={checked}
                    onChange={handleClickCheckbox}
                />
                <strong className={styles.columnName}>{headerName}</strong>
            </ScoopRow>
            <button className={styles.filterButton} aria-label="filter">
                {filterListCopy.filter((f) => f.attributeName === headerName)?.length > 0 && (
                    <div className={styles.filterIndicator} />
                )}
                <FunnelIcon size={16} onClick={handleOpen} className={styles.filterIcon} />
            </button>
            <FilterModal
                operator={operator}
                columnName={headerName}
                open={open}
                menuItems={menuItems}
                onClose={handleClose}
                id={id}
                setOperator={setOperator}
                allValues={allValues}
                filterList={filterListCopy}
                setChanges={setChanges}
                operatorValues={operatorValues}
                setOperatorValues={setOperatorValues}
                saveFilter2={saveFilter2}
                anchorEl={anchorEl}
            />
        </ScoopRow>
    )
}

export default ColumnHeader
